import axios from 'axios';
import { API_AUTHENTICATION, API_AUTHENTICATION_PROJECTK, API_SECURITY_ENDPOINT, API_SECURITY_PROJECTK_ENDPOINT, APP_HEADER_NAME } from '../../config/config';
export const revokeTokenUser = async () => {
    
    try {
        
        let revokeToken = {
            UserName: JSON.parse(sessionStorage.getItem("userTokenData")).nameid,
            Quantity: 1,
            AppName: JSON.parse(localStorage.getItem("_appName")),
            RefreshToken: sessionStorage.getItem("refreshToken")
        }
        const headers = {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "Access-Control-Allow-Origin": "*"
            },
        }
        const res = await axios.put(API_AUTHENTICATION + "/api/login/RevokeToken", revokeToken, headers)
        if (res.status === 200) {
            
            sessionStorage.removeItem('refreshToken');
            sessionStorage.removeItem('jwtToken');
            sessionStorage.removeItem('userTokenData');
            sessionStorage.removeItem('encryptedToken');
            const { data } = res;
            window.location.href = `${API_SECURITY_ENDPOINT}/api/redirect/verify?url=${encodeURI(data?.result?.information)}`;
        } else {
            return false;
        }

    } catch (error) {
        console.log("Error", error)
        

    }



}

export const getAppName = () => {
    axios.get();
}

export const readAppNameFromHeaders = () => {
    var request = new XMLHttpRequest();
    request.open("GET", document.location, false);
    request.send(null);
    return request.getResponseHeader(APP_HEADER_NAME);    
}

export const getEndpointAuthenticationByAppName = () => {
    const appName = readAppNameFromHeaders();
    
    switch (appName?.toLowerCase()) {
        case 'projectk':
            return API_AUTHENTICATION_PROJECTK;
        default:
            return API_AUTHENTICATION;
    }
}

export const getEndpointSecurityByAppName = () => {
    const appName = readAppNameFromHeaders();    
    
    switch (appName?.toLowerCase()) {
        case 'projectk':
            return API_SECURITY_PROJECTK_ENDPOINT;
        default:            
            return API_SECURITY_ENDPOINT;
    }
}